import React from "react";
import PropTypes from "prop-types";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { MenuContentItemForFloaty } from "@domestika-dev/prudencio/dist/molecules/Menu/MenuContentItem";
import {
  FontHeavy,
  ImageHeavy,
  PlayCircleHeavy,
  Arrange,
} from "@domestika-dev/prudencio/dist/atoms/Icons";
import { useIntl } from "react-intl";

import { ProjectFormMenuFixed } from ".";

export const ContentItemMenuFixed = ({
  addContentItem,
  isMobile,
  deleteProject,
  saveDraft,
  publishProject,
  deleteDisabled,
  publishDisabled,
  canOrganize,
  organizeAction,
  top,
  reference,
}) => {
  const intl = useIntl();

  const MenuContentItemOptions = [
    {
      id: "text",
      label: intl.formatMessage({ id: "projects.new.more_content_section.text.button" }),
      icon: <FontHeavy />,
      action: () => {
        addContentItem("text");
      },
      disabled: false,
    },
    {
      id: "s3image",
      label: intl.formatMessage({ id: "projects.new.more_content_section.image.button" }),
      icon: <ImageHeavy />,
      action: () => {
        addContentItem("s3image");
      },
      disabled: false,
    },
    {
      id: "embed",
      label: intl.formatMessage({ id: "projects.new.more_content_section.video.button" }),
      icon: <PlayCircleHeavy />,
      action: () => {
        addContentItem("embed");
      },
      disabled: false,
    },
    {
      id: "sort",
      label: intl.formatMessage({ id: "projects.new.more_content_section.organize.button" }),
      icon: <Arrange />,
      action: () => {
        organizeAction();
      },
      disabled: !canOrganize,
    },
  ];

  return (
    <Flex
      position={isMobile ? "fixed" : "sticky"}
      top={top}
      left={0}
      width="100%"
      backgroundColor={isMobile ? "copoazu" : "coco"}
      zIndex={11}
      height="auto"
      alignItems="center"
      justifyContent={isMobile ? "center" : "space-between"}
      paddingY={4}
      paddingX={5}
      ref={reference}
    >
      <Flex flexDirection="column">
        <MenuContentItemForFloaty options={MenuContentItemOptions} />
      </Flex>

      {!isMobile && (
        <Flex alignSelf="end">
          <ProjectFormMenuFixed
            deleteProject={deleteProject}
            saveDraft={saveDraft}
            publishProject={publishProject}
            deleteDisabled={deleteDisabled}
            publishDisabled={publishDisabled}
          />
        </Flex>
      )}
    </Flex>
  );
};

ContentItemMenuFixed.propTypes = {
  addContentItem: PropTypes.func,
  isMobile: PropTypes.bool,
  deleteProject: PropTypes.func,
  saveDraft: PropTypes.func,
  publishProject: PropTypes.func,
  deleteDisabled: PropTypes.bool,
  publishDisabled: PropTypes.bool,
  organizeAction: PropTypes.func,
  canOrganize: PropTypes.bool,
  top: PropTypes.number,
  reference: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

ContentItemMenuFixed.defaultProps = {
  addContentItem: () => {},
  isMobile: false,
  deleteProject: () => {},
  saveDraft: () => {},
  publishProject: () => {},
  deleteDisabled: false,
  publishDisabled: false,
  organizeAction: () => {},
  canOrganize: false,
  top: 0,
  reference: () => {},
};

export default ContentItemMenuFixed;
